import {Fragment, h} from 'preact';
import {useLayoutEffect, useRef} from 'preact/hooks';
import DeviceBadInfo from "./DeviceBadInfo";
import {formatPrice, formatPriceWithSymbol} from "../../tools";

export default function ServiceInfo({canEnterMeterReadings, enterUrl, contract, account, formParams, amounts, createOrderForContract, onChangeAmountInput, enterMeterDisabledButtonText, checkFineForContract, isFineChecked}){

	const useRunAfterUpdate = () => {
		const afterPaintRef = useRef(null);
		useLayoutEffect(() => {
			if(afterPaintRef.current) {
				afterPaintRef.current();
				afterPaintRef.current = null;
			}
		});
		const runAfterUpdate = fn => (afterPaintRef.current = fn);
		return runAfterUpdate;
	}
	const runAfterUpdate = useRunAfterUpdate();

	return (
		<div className={"debt-table-item debt-table__item " + (!formParams.allowedPayment ? 'debt-table-item-2_not-padding':'')}>
			<div className="debt-table-item-2__row">
				<div className="debt-table-item-2__col debt-table-item-2__col_checkbox">
					<div className="debt-table-item-2__col-title">
						<div className="text-dark debt-table-item-2__col-title-price">
							{amounts.debt >= 0 ? formatPriceWithSymbol(amounts.debt) : formatPriceWithSymbol(0)}
						</div><span className="debt-table-item__label">к оплате</span>
					</div>
				</div>
				<div className="debt-table-item-2__col">
						<Fragment>
							<div className="debt-table-item-2__button-container">
								<button className={amounts.total > 0 ? "button-primary button-primary_bgc_brand-2" : "button-primary button-primary_bgc_brand-2 disabled"} onClick={() => createOrderForContract(account.id, contract.id)} disabled={isFineChecked ? amounts.total <= 0 : amounts.debt <= 0}>Оплатить {formatPriceWithSymbol(isFineChecked ? amounts.total : amounts.debt)}</button>
							</div>
						</Fragment>
				</div>
			</div>
			{
				amounts.fine > 0
				&& <div className="debt-table-item-2__row">
					<div className="debt-table-item__col debt-table-item-2__col_checkbox">
						<label className="checkbox debt-table-item__checkbox">
							<input className="checkbox__input" type="checkbox" data-contract-id={contract.id} onChange={checkFineForContract(contract.id, account.id)} checked={isFineChecked}/><span className="checkbox__label debts-item-checkbox"/>
							<span className="checkbox__text">пеня: {formatPriceWithSymbol(amounts.fine)}</span>
						</label>
					</div>
				</div>
			}
			<DeviceBadInfo device={null} contract={contract} account={account} formParams={formParams}/>
		</div>
	)
}
